/*eslint-disable */
export const steps = {
  step1: 'step1',
  step2: 'step2',
  step3: 'step3',
  step4: 'step4',
};
